import { render, staticRenderFns } from "./Laureats.vue?vue&type=template&id=868eefb0"
import script from "./Laureats.vue?vue&type=script&lang=js"
export * from "./Laureats.vue?vue&type=script&lang=js"
import style0 from "./Laureats.vue?vue&type=style&index=0&id=868eefb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports